var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('select',{staticClass:"field",attrs:{"name":_vm.name},on:{"change":_vm.handleDeadlineChange}},_vm._l((_vm.dates),function(date){return _c('option',{domProps:{"value":date.value}},[_vm._v(_vm._s(date.label))])}),0),_vm._v(" "),_c('datepicker',{staticClass:"field-date field-date-hidden"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }